<template>
<div class="page-in">




  <div class="yo-text-xl" style="margin-bottom:52px;">Welcome {{$contatto.profile.row.nome}}&#160;{{$contatto.profile.row.cognome}}!</div>


  <div v-if="actionTime==10">
    
    You have successfully accessed your abstract submission personal page.
Here you can submit your abstract, change it or cancel it, check its evaluation status and upload your final e-poster or presentation.
<br />
We gently remind you that when submitting your abstract, you agree that the abstract and the corresponding poster/presentation, which you are going to show during the ESPHM, become subsequently available online.
<br />
Taking pictures of displayed poster or filming whole talks during sessions will not be allowed. Instead, you are required to provide us with material (pdf) that can be published.
<br />
Through this process, the Scientific Committee want to give all authors the chance to disseminate their latest findings in science in a much better quality than it has been possible in the past editions of this and other conferences.
<br />
<br />
<strong>IMPORTANT STEPS OF THE SUBMISSION PROCESS:</strong>
<ul>
<li>From October 1 to December 1, 2024: Authors can submit, edit or cancel their abstracts</li>
<li>From January 27 to 30, 2025: Authors should review their abstracts if required</li>
<li>February 14, 2025: Abstract final evaluation, authors will receive notification letters</li>
<li>February 26, 2025: Presenting author’ registration is required within the deadline</li>
<li>May 6, 2025: Deadline for e-poster and pdf presentation sending</li>
</ul>
<br />
In order to send an abstract, you simply need to click on “New Abstract” and follow the instructions below.

  </div>

  <div v-if="actionTime==20"><!--    Help da mettere per il periodo in cui i revisori stanno lavorando alla prima analisi -->
    <h4 class="yo-align-center yo-color-secondary yo-bold" style="margin-top:48px;">The abstract submission system is now closed, submitted abstracts are under review</h4>
  </div>
  
  <div v-if="actionTime==29">
    Help da mettere per il periodo in cui i sarà possibile fare le modifiche agli abstract in base alle indicazioni dei revisori
  </div>
  
  <div v-if="actionTime==30"><!--     Help da mettere per il periodo in cui i revisori stanno lavorando alla analisi finale -->
  </div>
  
  <div v-if="actionTime==39">
    Help da mettere per il periodo in cui i sarà possibile fare upload degli e-poster o delle presentazioni in base alla tipologia di abstract
  </div>
  
  <div v-if="actionTime==99">
    <h4 class="yo-align-center yo-color-secondary yo-bold" style="margin-top:48px;">The abstract submission system is closed</h4>
  </div>


  <div class="row" v-if="actionTime==10">
  <div class="col s12 m3 offset-m9">
      <el-button type="primary" class="yo-text-n" @click="newAbstract" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" >New Abstract</el-button>
  </div>
  </div>

  <div style="margin-top:32px;">
    <div v-if="$contatto._abstract.length>0">
      <abstractCerca></abstractCerca>
    </div>
    <div v-else>
      <div class="page_title title_h1 yo-color-primary">NO ABSTRACTS PRESENT</div>
      At the moment no abstracts have been submitted;<span v-if="actionTime==10"> to submit your work click on "New Abstract"</span>
    </div>
  </div>

</div>
</template>

<script>
import abstractCerca from './Abstract-cerca.vue'
export default {
  components: {
    abstractCerca
  },
  data () {
    return {
      loading: true,
      drawer: false
    }
  },
  created () {
    console.log("Arrivo al home.vue")
    if(this.$contatto.profile.row.eposter==0)
      this.drawer = true

  },
  methods: {
    newAbstract(){
      this.$abstract.profile.new().then((response) =>  {
        this.$abstract.profile.row.contatto = this.$contatto.profile.row.id
        this.$abstract.profile.row.evento = this.$evento.profile.row.id
        this.$abstract.profile.row.iniziatoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
        this.$abstract.init()
        this.$router.push('/abstract-profile') 
      })
    },
    agree(){
      this.$contatto.profile.row.eposter = 1
      this.$contatto.profile.save()
      this.drawer = false
    },
    disagree(){
      this.$contatto.profile.row.eposter = -1
      this.$contatto.profile.save()
      this.drawer = false
    }
  },
  computed:{
    _drawer: function(){
      let toShow = false
      if(this.$contatto.profile.row.eposter==0)
        toShow=true
      return toShow
    },

    actionTime:function(){
      let cosapossiamofareinbasealtempo=0
      if(this.$moment().isBefore(this.$evento.profile.row.deadline_invio)){
        //Possiamo inviare e modificare gli abstract
        cosapossiamofareinbasealtempo=10

      }else{
        if(this.$moment().isBefore(this.$evento.profile.row.deadline_revisione_inizio)){
          //Non possiamo fare nulla, siamo in attesa che i revisori verifichino gli abstract
          cosapossiamofareinbasealtempo=20
        }else{
          if(this.$moment().isBefore(this.$evento.profile.row.deadline_revisione_fine)){
            //Possiamo se richiesto modificare il nostro abstract come da richiesta dei revisori
            cosapossiamofareinbasealtempo=29
          }else{
            if(this.$moment().isBefore(this.$evento.profile.row.deadline_efile_inizio)){
              //Non possiamo fare nulla, siamo in attesa delle valutazioni finali dei revisori
              cosapossiamofareinbasealtempo=30
            }else{
              if(this.$moment().isBefore(this.$evento.profile.row.deadline_efile_fine)){
                //Possiamo se richiesto inviare gli efile di nostra competenza
                cosapossiamofareinbasealtempo=39
              }else{
                //In teoria non possiamo più fare nulla
                cosapossiamofareinbasealtempo=99
              }
            }

          }
        }
      }
      return cosapossiamofareinbasealtempo
    }
  }
  
}

</script>
<style>
#page{
  min-height:200px;
}.page-in{
  padding:0 20px;
}
</style>
